module.exports = __webpack_public_path__ + "img/agenda.7797d191.svg";